import { Controller } from '@hotwired/stimulus';
import { callApiWithoutBody } from '../common/AjaxUtil';

export default class extends Controller {
  static targets = [];

  static values = {
    groupId: Number,
  };

  connect() {}

  async deleteAllByGroupId(event) {
    callApiWithoutBody(`/api/notifications/group/${this.groupIdValue}`, 'DELETE')
      .then(() => {
        location.reload();
      })
      .catch((err) => {
        window.$reloadAndSendAlert(err.msg);
      });
  }

  async deleteById(event) {
    const notificationId = event.target.getAttribute('value');
    callApiWithoutBody(`/api/notifications/${notificationId}`, 'DELETE')
      .then(() => {
        location.reload();
      })
      .catch((err) => {
        window.$reloadAndSendAlert(err.msg);
      });
  }

  read(event){
    event.preventDefault();
    const notiId = event.params.id;
    const isRead = event.params.isRead;
    const url = event.params.url;
    if(isRead){
      location.href = url;
      return;
    }
    callApiWithoutBody(`/api/personal-notifications/${notiId}/read`, 'PUT')
    .then(()=>{
      location.href = url;
    }).catch(err=>{
      window.$reloadAndSendAlert(err.msg);
    });
  }
}
